export const SOCOTEC_GROUPS = {
  DEV: "Developer",
  APP_MANAGER: "AppManager",
  MATERIAL_MANAGER: "MaterialManager",
};
